import ValidateForm from '../class/ValidateForm';
import AjaxFormSubmission from '../class/AjaxFormSubmission';
import { tns } from "/node_modules/tiny-slider/src/tiny-slider"

$(document).ready(function() {

  if (document.querySelector('.careers-slider') != null) {
    var slider = tns({
      container: '.careers-slider',
      items: 1,
      slideBy: 'page',
      autoplay: true,
      autoplayTimeout: 5000,
      controls: false,
      navPosition: "bottom",
      mouseDrag: true,
      autoplayButtonOutput: false,
      responsive: {
        640: {
          items: 2
        },
        1200: {
          items: 3
        }
      }
    });
  }


  if (document.querySelector('[name="careers-inquiry-form"]') != null) {
    new ValidateForm('[name="careers-inquiry-form"]', {
      'afterValidationSuccess': new AjaxFormSubmission('.careers-inquiry-form', '.form-msg', {}, true),
    }).init();


    const fileInput = document.getElementById('upload_cv');
    const fileNameDisplay = document.getElementById('upload_cv_field_text');

    // Add an event listener to the file input
    fileInput.addEventListener('change', function () {
      // Check if a file is selected
      if (fileInput.files.length > 0) {
        // Get the first selected file
        const selectedFile = fileInput.files[0];

        // Update the text inside the display div with the file name
        fileNameDisplay.textContent = `${selectedFile.name}`;
      } else {
        // If no file is selected, clear the display div
        fileNameDisplay.textContent = '';
      }
    });





    const fileFullDiv = document.getElementById('upload_cv');
    const fileBtn = document.getElementById('upload_cv_field_btn');

    // Add an event listener to the fileFullDiv for mouseenter and mouseleave events
    fileFullDiv.addEventListener('mouseenter', function () {
      // Add a CSS class to the fileBtn to simulate hover
      fileBtn.classList.add('hovered');
    });

    fileFullDiv.addEventListener('mouseleave', function () {
      // Remove the CSS class when the mouse leaves the fileFullDiv
      fileBtn.classList.remove('hovered');
    });


    function watchForAlertSuccess(className, callback) {
      // Select the element you want to observe
      const targetElement = document.querySelector('.' + className);

      if (!targetElement) {
        console.error('Element with class "' + className + '" not found.');
        return;
      }

      // Create a MutationObserver to watch for class changes
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const currentClasses = mutation.target.classList;
            if (currentClasses.contains('alert-success')) {
              // 'alert-success' class found, trigger the callback
              callback();
              // Disconnect the observer if needed
              observer.disconnect();
            }
          }
        }
      });

      // Start observing the target element for attribute changes
      observer.observe(targetElement, { attributes: true });
    }

    // Example usage:
    watchForAlertSuccess('form-msg', () => {

      if ($('html').attr('lang') === "en") {
        $('#upload_cv_field_text').html('No File Chosen');
      }else{
        $('#upload_cv_field_text').html('Aucun fichier choisi');
      }
    });
  }
});




